export type ComponentName = 'RPFavToggleSectionComponent';

export const categoryToComponentMap: Record<string, ComponentName> = {
    homemygames: 'RPFavToggleSectionComponent',
};
